function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "svg_2",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  stroke: "#ffffff",
  fill: "none",
  d: "m30.217,35.252c0,0 4.049,-2.318 5.109,-2.875c1.057,-0.559 2.152,-0.7 2.817,-0.294c1.007,0.616 9.463,6.241 10.175,6.739c0.712,0.499 1.055,1.924 0.076,3.32c-0.975,1.396 -5.473,6.916 -7.379,6.857c-1.909,-0.062 -9.846,-0.236 -24.813,-15.207c-14.964,-14.966 -15.141,-22.905 -15.202,-24.814c-0.061,-1.908 5.459,-6.407 6.855,-7.383c1.398,-0.975 2.825,-0.608 3.321,0.078c0.564,0.781 6.124,9.21 6.736,10.176c0.419,0.66 0.265,1.761 -0.294,2.819c-0.556,1.06 -2.874,5.109 -2.874,5.109s1.634,2.787 7.16,8.312c5.527,5.526 8.313,7.163 8.313,7.163z"
});

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fd48604d.svg";
export { ForwardRef as ReactComponent };